import React from 'react';
import {
  initializeCollection,
  PagedCollectionProvider,
  usePagedCollectionDispatch,
  usePagedCollectionState,
} from 'Context/PagedCollectionContext';

const StateContext = React.createContext(undefined);
const DispatchContext = React.createContext(undefined);

const ManagedAccountTaxDocumentsContextProvider = ({
  taxDocumentsSelfLink,
  ...rest
}) => {
  if (!taxDocumentsSelfLink) {
    const { children } = rest;
    return children;
  }
  return (
    <PagedCollectionProvider
      StateContext={StateContext}
      DispatchContext={DispatchContext}
      initialState={{
        collectionSelfLink: taxDocumentsSelfLink,
      }}
      {...rest}
    />
  );
};

const initializeManagedAccountTaxDocumentsCollection = (dispatch, linkUrl) => {
  initializeCollection(dispatch, linkUrl);
};

const useManagedAccountTaxDocumentsDispatchContext = () => {
  const context = usePagedCollectionDispatch(DispatchContext);

  if (!context) throw new Error('useManagedAccountTaxDocumentsDispatchContext must be called from DispatchContext.Provider');

  return context;
};

const useManagedAccountTaxDocumentsStateContext = () => {
  const context = usePagedCollectionState(StateContext);

  if (!context) throw new Error('useManagedAccountTaxDocumentsDispatchContext must be called from StateContext.Provider');

  return context;
};

export {
  ManagedAccountTaxDocumentsContextProvider,
  useManagedAccountTaxDocumentsDispatchContext,
  useManagedAccountTaxDocumentsStateContext,
  initializeManagedAccountTaxDocumentsCollection,
};
